import { useEffect, useState } from "react";

export default ({ items, initial }) => {
	const matchFromUrl = initial
		? items?.find(
				(item) =>
					item.meta.urlValue === initial ||
					item.meta.url === initial ||
					item.meta.value === initial ||
					item.url === initial
		  )
		: null;

	const [selected, setSelected] = useState(
		matchFromUrl ? matchFromUrl.value : null
	);

	const reset = () => setSelected(matchFromUrl ? matchFromUrl.value : null);
	const isSelected = selected !== null;

	useEffect(() => {
		setSelected(matchFromUrl ? matchFromUrl.value : null);
	}, [initial]);

	return { matchFromUrl, selected, setSelected, reset, isSelected };
};
